// extracted by mini-css-extract-plugin
export default {"registration":"Registration_registration__z594t"};